export default __webpack_public_path__ + "static/media/(59).d8354ac7.jpg";